import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type { CouponReceive } from './type';

/**
 * 分页查询优惠券列表
 */
export const postCouponReceive = (couponRecordId: number | string): AxiosPromise<CouponReceive> => {
  return request({
    url: '/api/order/coupon/receive',
    method: 'post',
    data: { couponRecordId }
  });
};
